import { useParams } from "react-router-dom";
import CloneView from "@features/tools/view/interactive-materials-view/single-interactive-material-view/clone";

const CloneInteractiveMaterial = () => {
  const { id } = useParams<{ id: string }>();

  return <CloneView id={id!} />;
};

export default CloneInteractiveMaterial;
